<template>
	<div class="header-block">
		<div style="display: none;">Сейчас онлайн: {{count}}</div>

		<login-form v-if="!user.isAuth" v-bind:user="user"></login-form>

		<div v-if="!user.isAuth">
			<a href="/registration">Регистрация</a>
			<!-- &#149;
			<a href="">Забыли пароль</a> -->
		</div>

		<div class="mini-profile-block" v-if="user.isAuth">
			<img src="/images/avatar.png">
			<div class="mini-profile-info">
				<div class="mini-profile-name">{{user.name}}</div>
				<a href="/logout" title="Выйти"><i class="fa fa-sign-out"></i></a>
			</div>
		</div>
	</div>
</template>

<script>
	import LoginForm from './LoginForm.vue'

	export default {
		components: {
			'login-form': LoginForm
		},

		props: ['count', 'user'],
		template: '#header-block',

		data: function () {
			return {

			}
		},

		methods: {
			
		}
	}
</script>
